import React, { useContext, useEffect, useState } from 'react'
import Draggable from "react-draggable";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ModalDialog } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { addFormData, addVersionFormData, getVersionContainData, getVersionNumbering, uploadFileWithData } from '../../services/versionHistoryService';
import { Loader } from '../../utils/loader';
import { ThemeContext } from '../../layout/BaseLayout';
import { hanldeSortingArray } from '../../utils/sortingByColumn';

const versionContainsDragModal = (props) => {
    return (
        <Draggable handle=".modal-header">
            <ModalDialog {...props} />
        </Draggable>
    );
};

const imagemodal = (props) => {
    return (
        <Draggable handle=".modal-header">
            <ModalDialog {...props} />
        </Draggable>
    );
};

const VersionContains = () => {

    let toast = useContext(ThemeContext);

    const blankObj = {
        "id": null,
        "VersionId": "",
        "header": "",
        "text": "",
        "iconSrc": "",
        "imageId": "",
        "altName": "",
        "type": "",
        "status": true
    }

    const versionErrorObj = {
        "typeError": false,
        "headerError": false,
        "textError": false,
        "iconSrcError": false,
        "imageidError": false,
        "altNameError": false,
        "versionError": false
    }

    const [versionContainModalShow, setVersionContainModalShow] = useState(false);
    const [versionContainAddData, setVersionContainsAddData] = useState({ ...blankObj });
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
    const [versionContainsList, setVersionContainsList] = useState([]);
    const [filteredContainsList, setFilteredContainsList] = useState([]);
    const [selectedArr, setSelectedArr] = useState([]);
    const [versionList, setVersionList] = useState([]);
    const [filteredVersionList, setFilteredVersionList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [selectedType, setSelectedType] = useState("");
    const [isUploadModal, setIsUploadModal] = useState(false);
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [fileType, setFileType] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const [versionContainsAddError, setVersionContainsAddError] = useState(versionErrorObj)
    let defaultSortingOrderObj = {
        sortingOrder: 'asc',
        upDownArrowColumn: null,
        fieldType: null
    };
    const [sortingOrderObj, setSortingOrderObj] = useState({ ...defaultSortingOrderObj });

    const openVersionContainsModal = () => {
        setVersionContainModalShow(true);
        getAllVersionNumbers();
    }

    const onblurHeader = (val) => {
        const changedVal = val.replace(/ /g, "-")
        setVersionContainsAddData({ ...versionContainAddData, altName: changedVal })
    }

    useEffect(() => {
        if (!!versionContainAddData?.type) {
            const filterdVal = versionList?.filter((itm) => itm.type === versionContainAddData.type)
            setFilteredVersionList([...filterdVal])
        } else {
            setFilteredVersionList([]);
        }
    }, [versionContainModalShow, versionContainAddData.type])

    const closeVersionContainsModal = () => {
        setVersionContainModalShow(false);
        setVersionContainsAddError(versionErrorObj);
        setIsUploadModal(false);
        setPreview(null);
        setFile(null);
        // setVersionList([]);
        setVersionContainsAddData({ ...blankObj })
        setIsEdit(false);
        setDisableSubmitBtn(false);
    }

    const updateField = (fld, val) => {
        const dta = versionContainAddData
        dta[fld] = val;
        setVersionContainsAddData({ ...dta })
    }

    const addVersionData = () => {

        let isValid = true;

        let tempErrorobj = {...versionContainsAddError};

        if (!versionContainAddData.type || versionContainAddData.type === "") {
            setDisableSubmitBtn(false);
            tempErrorobj.typeError = true;
            isValid = false;
        }
        if (!versionContainAddData.VersionId || versionContainAddData.VersionId === "") {
            setDisableSubmitBtn(false);
            tempErrorobj.versionError = true;
            isValid = false;
        }
        if (!versionContainAddData.header || versionContainAddData.header === "") {
            setDisableSubmitBtn(false);
            tempErrorobj.headerError = true;
            isValid = false;
        }
        if (!versionContainAddData.text || versionContainAddData.text === "") {
            setDisableSubmitBtn(false);
            tempErrorobj.textError = true;
            isValid = false;
        }
        if (!versionContainAddData.iconSrc) {
            if (!file) {
                setDisableSubmitBtn(false);
                tempErrorobj.iconSrcError = true;
                isValid = false;
                toast.error("Image required!!")
            }
        }

        setVersionContainsAddError({...tempErrorobj})
        let frmData = new FormData();
        if (isEdit) {
            frmData.append("Id", versionContainAddData?.id);
        }
        frmData.append("VersionId", versionContainAddData?.VersionId);
        frmData.append("header", versionContainAddData?.header);
        frmData.append("text", versionContainAddData?.text);
        frmData.append("altName", versionContainAddData?.altName);
        frmData.append("type", versionContainAddData?.type);
        frmData.append("status", versionContainAddData?.status);
        frmData.append("file", file ? file : []);

        if (isValid) {
            setDisableSubmitBtn(true);
            addVersionFormData(frmData).then((res) => {
                setDisableSubmitBtn(false);
                if (res.isSuccess) {
                    let tempNumbList = [...versionContainsList];
                    let index = versionContainsList?.findIndex((itm) => itm.id === versionContainAddData.id);
                    tempNumbList[index] = res?.data;
                    if (index !== -1) {
                        setFilteredContainsList([...tempNumbList])
                    } else {
                        setFilteredContainsList([...versionContainsList, res.data]);
                    }
                    setVersionContainModalShow(false);
                    setVersionContainsAddData({ ...blankObj })
                    setFile(null);
                    setPreview(null);
                    toast.success(res?.successMessage);
                } else {
                    setVersionContainModalShow(false);
                    toast.error(res.exception.message);
                }
            }).catch(e => {
                setDisableSubmitBtn(false);
            })
        }
    }

    const getVersionsContains = () => {
        setLoader(true);
        getVersionContainData().then((res) => {
            setLoader(false);
            if (res.isSuccess) {
                setVersionContainsList(res.data);
                setFilteredContainsList(res.data);
            }
        }).catch(e => {
            setLoader(false);
        })
    }

    const getAllVersionNumbers = () => {
        getVersionNumbering().then((res) => {
            if (res.isSuccess) {
                setVersionList(res.data);
            }
        })
    }

    const editVersionContainsAddModal = (itm) => {
        getAllVersionNumbers();
        setPreview(`https://${itm.iconSrc}`)
        setVersionContainsAddData({
            "id": itm.id,
            "VersionId": itm.VersionId || "",
            "header": itm.header || "",
            "text": itm.text || "",
            "iconSrc": itm.iconSrc || "",
            "imageId": itm.imageId || "",
            "altName": itm.altName || "",
            "type": itm.type || "",
            "status": itm.status || ""
        })
        setVersionContainModalShow(true);
        setIsEdit(true);
    }

    const onSelectionRow = (item) => {
        if (!!filteredContainsList && filteredContainsList.length > 0) {
            const selectedRow = filteredContainsList.map((elem) => { return elem.id }).indexOf(item.id);
            if (selectedRow > -1) {
                setSelectedArr([filteredContainsList[selectedRow]]);
            }
        }
    }

    const checkItem = (item) => {
        const checkData = !!selectedArr && selectedArr.some((val) => val?.id === item?.id);
        return checkData;
    }

    const creatingSortingArrFn = (field, type) => {
        let order = sortingOrderObj.sortingOrder;
        if (field === sortingOrderObj.upDownArrowColumn) {
            order = order === 'asc' ? 'desc' : 'asc';
            setSelectedArr([]);
        } else {
            order = 'asc';
            setSelectedArr([]);
        }
        setSortingOrderObj({ sortingOrder: order, upDownArrowColumn: field, fieldType: type })
    }

    useEffect(() => {
            if (!!sortingOrderObj && sortingOrderObj.upDownArrowColumn !== '') {
                let sortedArrayByColumn = [...filteredContainsList]
                sortedArrayByColumn = hanldeSortingArray(sortedArrayByColumn, sortingOrderObj.upDownArrowColumn, sortingOrderObj.fieldType, sortingOrderObj.sortingOrder)
                setFilteredContainsList(sortedArrayByColumn);
            }
        }, [sortingOrderObj])

    useEffect(() => {
        getVersionsContains();
        getAllVersionNumbers();
    }, [])

    useEffect(() => {
        if (!!selectedType) {
            let filterData = versionContainsList?.filter((itm) => itm.type === selectedType)
            setFilteredContainsList([...filterData]);
        } else {
            setFilteredContainsList([...versionContainsList])
        }
    }, [selectedType])

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        const reader = new FileReader();
        reader.onloadend = () => {
            setPreview(reader.result);
            setFileType(selectedFile.type);
        };
        reader.readAsDataURL(selectedFile);
    };

    const openImageModal = (itm) => {
        setShowImageModal(true);
        setSelectedImage(`https://${itm}`)
    }

    const closeImageModal = () => {
        setShowImageModal(false);
    }

    return (
        <div id='tabs'>
            {loader && <Loader />}
            <div className="maintitle-box">
                <div className="w-50 d-inline-block">
                    <h2 className="maintitle "><img className="main-title-img" src={"/images/svg/connectionencryptdescript.svg"} alt="" />Version Contains</h2>
                </div>
                <div className="w-50 d-inline-block">
                    <div className="float-end ">
                        <div className="d-inline-block mr-3"><i id="feedModuleRefresh" className="fa fa-refresh font-size-14 remove_arrow_summary" onClick={() => { getVersionsContains(); }}></i>
                        </div>
                        <button className="addnewbtn mb-0" onClick={() => { openVersionContainsModal() }}>
                            <i className="fa-solid fa-circle-plus mr-2"></i>Add
                        </button>
                    </div>
                </div>
            </div>
            <div className='mt-2 mb-3 px-3'>
                <div className='d-flex align-items-center'>
                    <div className='client-po-id text-right mr-2'>Type:</div>
                    <div className=''>
                        <select className='w-250 form-select inputborder font11' value={selectedType} onChange={(e) => { setSelectedType(e.target.value); }}>
                            <option value="">Select</option>
                            <option value="Admin">Admin</option>
                            <option value="Dealer">Dealer</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className="thead-fixed">
                <table className="table table-bordered table-strip w-100 mb-30 new-data-asc-desc">
                    <thead>
                        <tr className="thead-dard-bg">
                            <th className=" srn-width">Sr</th>
                            <th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'type' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('type', 'Text')}>Type</th>
                            <th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'VersionId' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('VersionId', 'Text')}>Version</th>
                            {/* <td className="w65-leverage">Secret Key</td> */}
                            <th className={`w-250 sorting sorting_${sortingOrderObj.upDownArrowColumn === 'header' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('header', 'Text')}>Header</th>
                            <th className={`sorting sorting_${sortingOrderObj.upDownArrowColumn === 'text' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('text', 'Text')}>Text </th>
                            <th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'iconSrc' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('iconSrc', 'Text')}>Image </th>
                            {/* <th>Upload Img </th> */}
                            {/* <th className={`sorting sorting_${sortingOrderObj.upDownArrowColumn === 'imageId' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('imageId', 'Text')}>Img Id </th> */}
                            {/* <th className={`sorting sorting_${sortingOrderObj.upDownArrowColumn === 'altName' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('altName', 'Text')}>Alt Name </th> */}
                            <th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'status' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('status', 'Status')}>Status </th>
                        </tr>
                    </thead>
                    <tbody>
                        {!!filteredContainsList && filteredContainsList.length > 0 && filteredContainsList.map((item, i) => {
                            return (
                                <tr key={"versionNumber" + i} onDoubleClick={() => { editVersionContainsAddModal(item) }} onClick={() => onSelectionRow(item)}
                                    className={`${!item.status ? "text-pink" : ''} ${checkItem(item) ? 'selected-tr' : ''} `}>
                                    <td className="">{i + 1}</td>
                                    <td className="">{item.type}</td>
                                    <td className="">{item.VersionId}</td>
                                    <td className="">{item.header}</td>
                                    <td className="">{item.text}</td>
                                    <td className=""><i className="fa-solid fa-image" onClick={() => openImageModal(item.iconSrc)}></i></td>
                                    {/* <td className=""><button className='h20' onClick={() => uploadImg(item)}>Upload Img</button></td> */}
                                    {/* <td className="">{item.imageId}</td> */}
                                    {/* <td className="">{item.altName}</td> */}
                                    <td className="">{item.status ? "Active" : "Inactive"}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <div className="login-popup">
                <Modal
                    className="login feed-modules"
                    show={versionContainModalShow}
                    onHide={() => closeVersionContainsModal()}
                    backdrop="static"
                    dialogAs={versionContainsDragModal}
                    animation={false}
                    size="md"
                    centered
                >
                    <Modal.Header closeButton style={{ border: "none" }}>
                        <Modal.Title className="w-100">
                            Version Contains
                            <div className="btn-help d-inline-block float-right ">
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                        <div>
                            <div className={`fidderbox-inner ${isUploadModal ? "version-contain-img-height" : "version-contain-height"}`}>
                                <div className="">
                                    <table border="0" cellSpacing="0" cellPadding="0" className="w-100">
                                        <tbody>
                                            <tr>
                                                <td className="feederw-200 font11 text-right font11 v-align-baseline">Type:</td>
                                                <td className={`feederw-300 loginUser`}>
                                                    <select
                                                        className={`w-100 form-select inputborder font11 ml-2 mb-2 ${versionContainsAddError.typeError && 'error'}`}
                                                        value={versionContainAddData.type}
                                                        onChange={(e) => { updateField("type", e.target.value); (e.target.value === '' ? setVersionContainsAddError({ ...versionContainsAddError, typeError: true }) : setVersionContainsAddError({ ...versionContainsAddError, typeError: false }))}}>
                                                        <option value="">Select</option>
                                                        <option value="Admin">Admin</option>
                                                        <option value="Dealer">Dealer</option>
                                                    </select>
                                                </td>
                                                <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td className="feederw-200 font11 text-right font11 v-align-baseline">Version:</td>
                                                <td className={`feederw-300 loginUser `}>
                                                    <select
                                                        className={`w-100 form-select inputborder font11 ml-2 mb-2 ${versionContainsAddError.versionError && 'error'}`}
                                                        value={String(versionContainAddData.VersionId)}
                                                        onChange={(e) => { updateField("VersionId", e.target.value); (e.target.value === '' ? setVersionContainsAddError({ ...versionContainsAddError, versionError: true }) : setVersionContainsAddError({ ...versionContainsAddError, versionError: false }))}}>
                                                        <option value="">Select</option>
                                                        {!!filteredVersionList && filteredVersionList?.length > 0 && filteredVersionList?.map((itm) => {
                                                            return (
                                                                <>
                                                                    <option key={itm.versionNumber} value={String(itm.versionNumber)}>{itm.versionNumber}</option>
                                                                </>
                                                            )
                                                        })}
                                                    </select>
                                                </td>
                                                <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td className="feederw-200 font11 text-right font11 v-align-baseline">Version Heading:</td>
                                                <td className={`feederw-300 loginUser ${versionContainsAddError.headerError && 'error'}`}>
                                                    <input
                                                        type="text"
                                                        className="inputborder font11 w-100  ml-2 h20 mb-2"
                                                        name="header"
                                                        autocomplete="off"
                                                        value={versionContainAddData.header}
                                                        onChange={(e) => { updateField("header", e.target.value); (e.target.value === '' ? setVersionContainsAddError({ ...versionContainsAddError, headerError: true }) : setVersionContainsAddError({ ...versionContainsAddError, headerError: false })) }}
                                                        onBlur={(e) => onblurHeader(e.target.value)}
                                                    /> </td>
                                                <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td className="feederw-200 font11 text-right font11 v-align-baseline">Version Content:</td>
                                                <td className={`feederw-300 text-right false ${versionContainsAddError.textError && 'error'}`}>
                                                    <textarea
                                                        type="text"
                                                        className="inputborder font11 w-100  ml-2 h70 mb-2"
                                                        name="text"
                                                        value={versionContainAddData.text}
                                                        onChange={(e) => { updateField("text", e.target.value); (e.target.value === '' ? setVersionContainsAddError({ ...versionContainsAddError, textError: true }) : setVersionContainsAddError({ ...versionContainsAddError, textError: false })) }}
                                                    ></textarea>
                                                </td>
                                                <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td className="feederw-200 font11 text-right font11 v-align-baseline">Image:</td>
                                                <td className={`feederw-300 `}>
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={handleFileChange}
                                                        className='ml-2 mb-2'
                                                    />
                                                    {preview && (
                                                        <div>
                                                            <div>
                                                                <img className='feedback-img mb-2 mt-2 version-modal-body' src={preview} alt={`File preview`} />
                                                            </div>
                                                        </div>
                                                    )
                                                    }
                                                </td>
                                                <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td className="feederw-200 font11 text-right font11 v-align-baseline">Image Alt Text:</td>
                                                <td className={`feederw-300 ${versionContainsAddError.altNameError && 'error'}`}>
                                                    <input
                                                        type="text"
                                                        className="inputborder font11 w-100  ml-2 h20 mb-2"
                                                        name="altName"
                                                        autocomplete="off"
                                                        value={versionContainAddData.altName}
                                                        onChange={(e) => {
                                                            updateField("altName", e.target.value);
                                                            (e.target.value === '' ? setVersionContainsAddError({ ...versionContainsAddError, altNameError: true }) : setVersionContainsAddError({ ...versionContainsAddError, altNameError: false }))
                                                        }}
                                                    /></td>
                                                <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td className="symbolrw-150 text-right font11 ">Status:</td>
                                                <td colspan="2" className="symbolrw-430 officeuser-redio-feed">
                                                    <div className="form-check-inline width-50 mb-2 mr-4">
                                                        <label className="form-check-label marginleft25group">
                                                            <input
                                                                type="radio"
                                                                className="form-check-input mt-1"
                                                                name="numbersStatus"
                                                                onChange={(e) => { updateField("status", true) }}
                                                                checked={versionContainAddData.status}
                                                            />Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check-inline width-50">
                                                        <label className="form-check-label ml-3">
                                                            <input
                                                                type="radio"
                                                                className="form-check-input mt-1"
                                                                name="numbersStatus"
                                                                onChange={(e) => { updateField("status", false) }}
                                                                checked={!versionContainAddData.status}
                                                            />No
                                                        </label>
                                                    </div>
                                                </td>
                                                <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div>
                            <div className="w-100 text-right p-1">
                                <Button className="btnmain mr-3"
                                    onClick={() => { addVersionData(); }}
                                    disabled={disableSubmitBtn}
                                >
                                    {disableSubmitBtn && <i className="fa fa-spinner fa-spin mr-2"></i>}Submit
                                </Button>
                                <Button onClick={() => closeVersionContainsModal()} className="btnmain-danger">
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
            <div className="login-popup">
                <Modal className="login version-popup"
                    show={showImageModal}
                    onHide={() => closeImageModal()}
                    backdrop="static"
                    dialogAs={imagemodal}
                    animation={false}
                    size="sm"
                    centered
                >
                    <Modal.Header closeButton style={{ border: "none" }}>
                        <Modal.Title>Version Image</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                        <div className='version-img-popup'>
                            <img src={selectedImage} alt="preview" className="modal-content" />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="">
                            <div className="w-100 text-right">
                                <Button onClick={() => closeImageModal()} className="btnmain-danger btn btn-primary"> Cancel </Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    )
}

export default VersionContains